var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.type === 'signalMap')?_c('header',[_vm._v("Mapxus Positioning SDK")]):_c('header',[_vm._v("\n        "+_vm._s(_vm.type === 'digitalMap' && _vm.device === 'rn' ? 'Mapxus Map React Native SDK' : 'Mapxus Map SDK')+"\n    ")]),_c('hr'),_c('div',{staticClass:"word",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }